<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <h3>{{ $t("toolbar.adminUsers.manageUsers") }}</h3>
    <b-tabs content-class="mt-3">
      <b-tab v-if="user.is_superuser" :title="$t('toolbar.adminUsers.users')">
        <AdminUsersTable
          :key="roles.length + '-' + identifier_types.length"
          :roles="roles"
          :allows_crud="allows_crud"
          :identifier_types="identifier_types"
        ></AdminUsersTable>
      </b-tab>
      <b-tab :title="$t('toolbar.adminUsers.roles')">
        <GroupNameAssignment
          :allows_crud="allows_crud"
          @created="slotCreatedRole"
          @updated="slotUpdatedRole"
          @delete="slotDeleteRole"
        ></GroupNameAssignment
      ></b-tab>
      <!-- **************************************** Pestaña de Recuadro Roles y Funciones **************************************** -->
    </b-tabs>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "AdminUsersView",
  components: {
    AdminUsersTable: () => import("./AdminUsersTable"),
    GroupNameAssignment: () => import("./GroupNameAssignment"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      roles: [],
      identifier_types: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      users: names.USERS,
    }),
    allows_crud() {
      // this.$hasPermissions("");
      // return false;
      const has_permission = this.$hasPermissions("teaching.change_access");
      if (has_permission) return has_permission;
      else return false;
    },
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        { text: this.$t("toolbar.adminUsers.manageUsers") },
      ];
    },
  },
  methods: {
    slotCreatedRole(role) {
      this.roles.push(role);
    },
    slotDeleteRole(role_id) {
      const index = this.roles.findIndex((x) => x.id == role_id);
      if (index != -1) this.roles.splice(index, 1);
    },
    slotUpdatedRole(role) {
      const index = this.roles.findIndex((x) => x.id == role.id);
      if (index != -1) {
        this.roles[index] = role;
      }
    },
  },
  mounted() {},
  created() {
    this.$restful.GetAll(`/common/identifer-type/`).then((response) => {
      this.identifier_types = response;
    });
    this.$restful.GetAll(`/teaching/roles/`).then((response) => {
      this.roles = response;
    });
    // Para la información de los estudiantes
    this.$store.dispatch(names.FETCH_EGRESS_PROFILES);
    // this.$store.dispatch(names.FETCH_CAREERS);
    // this.$store.dispatch(names.FETCH_FACULTIES);
    // this.$store.dispatch(names.FETCH_EGRESS_PROFILES);
    // this.$store.dispatch(names.FETCH_MATTERS);
    // this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS);
  },
};
</script>

<style scoped>
</style>